import { Stack, Typography } from '@prenuvo/halo';

import { CwfActiveDocument, Loading, PatientDocIframe, PdfViewer } from '@/shared/ui';
import { generateMhsDocumentUrl, generateRadiologyReportDocumentUrl } from '@/shared/util';

import { PatientDocument } from '../patient-docs-side-panel.model';

interface PatientDocProps {
  document: PatientDocument;
}

export function PatientDoc({ document: { link } }: PatientDocProps) {
  return (
    <div className="overflow-hidden px-2 pb-2">
      {link.type === 'MHS' && <PatientDocIframe url={generateMhsDocumentUrl(link.studyId)} />}

      {link.type === 'RADIOLOGY_REPORT' && (
        <PdfViewer
          className="max-h-[calc(100vh-128px)]"
          error={
            <Stack alignment="center" className="h-[calc(100vh-128px)]" justification="center">
              <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT.ERROR" />
            </Stack>
          }
          loading={<Loading className="h-[calc(100vh-128px)]" />}
          url={generateRadiologyReportDocumentUrl(link.studyId)}
        />
      )}

      {link.type === 'CWF' && (
        <CwfActiveDocument
          careActivityId={link.careActivityId}
          carePlanId={link.carePlanId}
          className="h-[calc(100vh-128px)]"
          studyId={link.studyId}
          typeId={link.typeId}
        />
      )}
    </div>
  );
}
